import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { flex } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    mainWrapper: {
        height: '100%',
        width: '100%',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: theme.colors.white,
        borderBottom: `1.5px solid ${theme.colors.grey_light}`,
        display: 'flex',
        padding: `0 ${theme.spacing(4)}`,
        gap: theme.spacing(2),
        overflow: 'hidden',
        [theme.down('desktop')]: {
            flexWrap: 'nowrap',
            padding: `0 ${theme.spacing(3)}`,
        },
        [theme.down('tablet')]: {
            padding: `0 ${theme.spacing(2)}`,
        },
    },

    headingWrapper: {
        ...flex('row', 'space-between', 'center'),
        minWidth: 0,
        flex: 1,
    },

    titleWrapper: {
        ...flex('row', '', 'center'),
        flexGrow: 1,
        justifyContent: 'space-between',
        minWidth: 0,
        overflow: 'hidden',
        '& .MuiTypography-root': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    },

    titleInput: {
        flexGrow: 1,
        maxWidth: 360,
        '& .MuiInputBase-input': {
            fontFamily: theme.font.secondary,
            fontSize: '1.25rem',
            color: theme.colors.black,
        },
    },

    editWrapper:{
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        flexShrink: 0,
        [theme.down('desktop')]: {
            width: 'auto',
            justifyContent: 'flex-end',
        },
    },

    editButton: {
        minWidth: 96,
        height: 40,
        [theme.down('desktop')]: {
            width: 'auto',
            minWidth: 88,
        },
    },

    iconButton: {
        width: 44,
        height: 44,
        border: `1px solid ${theme.colors.grey_light}`,
        borderRadius: theme.radius * 2,
    },

    iconButtonPrimary: {
        width: 44,
        height: 44,
        borderRadius: theme.radius * 2,
        color: theme.colors.white,
        background: theme.colors.violet_primary,
        '&:hover': {
            background: theme.colors.violet_primary,
        },
        '&.Mui-disabled': {
            background: theme.colors.grey_light,
            color: theme.colors.grey_text,
        },
    },
}));
